import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, TransitionGroup as _TransitionGroup, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap gap-3 mb-3" }
const _hoisted_2 = ["id", "onUpdate:modelValue"]
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "d-flex flex-grow-1 justify-content-between align-items-center gap-3" }
const _hoisted_5 = { class: "text-center my-3" }
const _hoisted_6 = {
  key: 0,
  class: "text-center my-1 test"
}
const _hoisted_7 = {
  key: 1,
  class: "text-center"
}
const _hoisted_8 = { class: "text-danger my-1" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BPopover = _resolveComponent("BPopover")
  const _component_BListGroupItem = _resolveComponent("BListGroupItem")
  const _component_Draggable = _resolveComponent("Draggable")
  const _component_BButton = _resolveComponent("BButton")
  const _component_BSpinner = _resolveComponent("BSpinner")
  const _component_b_button = _resolveComponent("b-button")
  const _component_BTh = _resolveComponent("BTh")
  const _component_BTr = _resolveComponent("BTr")
  const _component_BTable = _resolveComponent("BTable")
  const _component_BOverlay = _resolveComponent("BOverlay")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[9] || (_cache[9] = _createElementVNode("h5", null, [
      _createTextVNode(" Verfügbare Dimensionen "),
      _createElementVNode("i", {
        id: "help-popover",
        class: "bi bi-question-circle text-secondary ms-1",
        style: {"cursor":"pointer"}
      })
    ], -1 /* CACHED */)),
    _createVNode(_component_BPopover, { target: "help-popover" }, {
      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
        _createTextVNode(" Die Dimensionen können mit der Maus angewählt und verschoben werden. Bitte die Tabelle danach wieder neu laden.", -1 /* CACHED */),
        _createElementVNode("br", null, null, -1 /* CACHED */),
        _createTextVNode(" Mit Klick auf die Inhalte der Tabelle können Sie die Dimensionen erweitern. ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Draggable, {
        modelValue: $data.availableDimensions,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.availableDimensions) = $event)),
        class: "list-group list-group-horizontal-md",
        animation: 200,
        "ghost-class": "ghost",
        onUpdate: $options.blockAnimation
      }, {
        default: _withCtx(() => [
          _createVNode(_TransitionGroup, {
            name: $data.isDragging ? 'no-animation' : 'dimension-list'
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.availableDimensions, (dim) => {
                return (_openBlock(), _createBlock(_component_BListGroupItem, {
                  key: dim.id,
                  class: "dimension-list-group-item",
                  active: dim.selected,
                  variant: dim.selected ? 'success' : 'default'
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      id: `dim-${dim.id}`,
                      "onUpdate:modelValue": $event => ((dim.selected) = $event),
                      type: "checkbox",
                      class: "d-none"
                    }, null, 8 /* PROPS */, _hoisted_2), [
                      [_vModelCheckbox, dim.selected]
                    ]),
                    _createElementVNode("label", {
                      for: `dim-${dim.id}`,
                      style: {"cursor":"inherit"}
                    }, _toDisplayString(dim.label), 9 /* TEXT, PROPS */, _hoisted_3)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["active", "variant"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["name"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue", "onUpdate"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_BButton, {
          class: "d-flex justify-content-between gap-3",
          variant: "outline-secondary",
          onClick: $options.loadTable
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode(" Tabelle laden ", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"]),
        _createVNode(_component_BButton, {
          class: "float-right",
          variant: "outline-secondary",
          onClick: _cache[1] || (_cache[1] = $event => ($data.showSemesters = !$data.showSemesters))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Fachsemester " + _toDisplayString($data.showSemesters ? 'ausblenden': 'einblenden'), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createVNode(_component_BOverlay, {
      show: $data.showOverlay,
      variant: "light",
      opacity: "1"
    }, {
      overlay: _withCtx(() => [...(_cache[6] || (_cache[6] = [
        _createTextVNode(" Bitte Dimensionen auswählen und Tabelle laden. ", -1 /* CACHED */)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_BTable, {
          ref: "table",
          busy: $data.isBusy,
          "onUpdate:busy": _cache[3] || (_cache[3] = $event => (($data.isBusy) = $event)),
          hover: "",
          small: "",
          "show-empty": "",
          responsive: "",
          "head-variant": "dark",
          "sticky-header": "100%",
          class: "bootstrap-vue-table-borders",
          fields: [...$options.dynamicFields, ...$options.staticFields],
          items: $data.items,
          style: _normalizeStyle({cursor: $data.isBusy ? 'wait' : 'auto', userSelect: 'none'}),
          "tbody-tr-class": $options.rowClasses,
          onRowClicked: $options.rowClicked
        }, _createSlots({
          empty: _withCtx(() => [
            (!$data.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Keine passenden Ergebnisse gefunden. "))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, " Ein Fehler ist aufgetreten (" + _toDisplayString($data.error.message) + "). ", 1 /* TEXT */),
                  _createVNode(_component_b_button, {
                    onClick: _cache[2] || (_cache[2] = $event => ($options.fetchData($options.dimensions[0])))
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("i", { class: "fa-solid fa-rotate-right me-1" }, null, -1 /* CACHED */),
                      _createTextVNode("Erneut versuchen. ", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  })
                ]))
          ]),
          "thead-top": _withCtx(() => [
            ($data.showSemesters)
              ? (_openBlock(), _createBlock(_component_BTr, {
                  key: 0,
                  variant: "light",
                  class: "border-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BTh, {
                      colspan: $options.dynamicFields.length + 2,
                      class: "invisible border-0"
                    }, null, 8 /* PROPS */, ["colspan"]),
                    _createVNode(_component_BTh, {
                      colspan: "13",
                      class: "text-center border-0",
                      variant: "secondary"
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode(" Fachsemester ", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          "cell()": _withCtx(({value}) => [
            _createTextVNode(_toDisplayString(value !== null ? value : 'ohne'), 1 /* TEXT */)
          ]),
          "cell(instituteName)": _withCtx(({value}) => [
            (value==='mhs')
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "MHS"))
              : _createCommentVNode("v-if", true),
            (value==='ifm')
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "IfM"))
              : _createCommentVNode("v-if", true)
          ]),
          "cell(isAccreditedName)": _withCtx(({value}) => [
            (value===true)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Ja"))
              : _createCommentVNode("v-if", true),
            (value===false)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Nein"))
              : _createCommentVNode("v-if", true)
          ]),
          _: 2 /* DYNAMIC */
        }, [
          (!$data.items.length)
            ? {
                name: "table-busy",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 0.1, 0.2], (delay, index) => {
                      return _createVNode(_component_BSpinner, {
                        key: index,
                        style: _normalizeStyle({animationDelay: delay + 's'}),
                        small: "",
                        type: "grow",
                        variant: "secondary"
                      }, null, 8 /* PROPS */, ["style"])
                    }), 64 /* STABLE_FRAGMENT */))
                  ])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["busy", "fields", "items", "style", "tbody-tr-class", "onRowClicked"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"])
  ], 64 /* STABLE_FRAGMENT */))
}